/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getUproColor } from "utils/colors";
import { makeNiceText } from "utils/formatters";

const getRows = (data, accion) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        type: <SoftBox display="flex" alignItems="center"></SoftBox>,
        orden: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {item?.orden || "No asignado"}
            </SoftTypography>
          </SoftBox>
        ),
        nombre: (
          <SoftBox>
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              fontWeight={item.disponibilidad ? "bold" : "light"}
            >
              {item?.nombre ? makeNiceText(item?.nombre) : "Sin nombre"}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox mr={2} display="flex" flexDirection="row">
            <Tooltip title="Editar" placement="top">
              <Icon
                // color="dark"
                fontSize="small"
                sx={{
                  cursor: "pointer",
                  color: getUproColor("uproGreen"),
                }}
                onClick={() => {
                  accion("editar", item);
                }}
              >
                edit
              </Icon>
            </Tooltip>
            <Tooltip title="Borrar" placement="top">
              <Icon
                fontSize="small"
                sx={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  accion("borrar", item);
                }}
              >
                cancel
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  { name: "orden", desc: "Orden", align: "left" },
  { name: "nombre", desc: "Nombre", align: "left" },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
